enum WorldpayMarketCode {
  FoodRestaurant = 'FoodRestaurant',
  Retail = 'Retail',
}

export { WorldpayMarketCode };
